/**
 * Config object for SystemJS
 */
const config = {
  /** 
   * Use for defaulting file endings when resolving a "folder entry" in the import map
   * e.g. QlikSystem.resolve("entry/path/to/file") -> "http://some-url/path/to/file.js" 
   * if DEFAULT_RESOLVE was set to .js
   */
  DEFAULT_RESOLVE: '',

  /**
   * Loading resources from this host needs to add credentials
   * Typically used in a cross-site domain scenario
   */
  ACCESS_CONTROL_HOST_WITH_CREDENTIALS: '',

  /**
   * crossorigin attribute to be used when fetching systemjs modules from ACCESS_CONTROL_HOST_WITH_CREDENTIALS if set
   * Defaults to "anonymous"
   */
  ACCESS_CONTROL_CROSS_ORIGIN: 'anonymous'
}

export function getConfig() {
  return config;
}
